<template>
  <div>
    <yd-flexbox  class="part1" v-bind:class="{ part1_bg: bgActive  }">
        <slot name="part1_img" :src="src" ></slot>
        <yd-flexbox-item style="padding-left: 0.15rem;">
          <slot name="part1_title"></slot>
          <slot name="part1_address"></slot>
          <slot name="part1_style" ></slot>
        </yd-flexbox-item>
        <slot name="part1_tell" style="height: 1rem"></slot>
    </yd-flexbox>

    <div class="part2" v-bind:class="{ unActive: isActive }">
        <div style="float: left;width: 5rem;">
            <slot name="part2_title"></slot>
            <slot name="part2_carStyle" ></slot>
            <slot name="part2_style" ></slot>
            <slot name="part2_priceTip"></slot>
            <slot name="part2_price"></slot>
        </div>
      <div style="width: 1.15rem;float: right;">
        <slot name="part2_apply"></slot>
      </div>
    </div>
    <div class="part3" v-bind:class="{ unActive: isActive }">
        <div style="float: left;width: 5rem;">
            <slot name="part3_title"></slot>
            <slot name="part3_carStyle" ></slot>
            <slot name="part3_style" ></slot>
            <slot name="part3_priceTip"></slot>
            <slot name="part3_price"></slot>
        </div>
      <div style="width: 1.15rem;float: right;">
        <slot name="part3_apply"></slot>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'AppAddress',
    props: {
      src: {
        type: String,
        default: 'http://static.ydcss.com/uploads/ydui/1.jpg',
      },
//    part2，part3是否-不展示
      isActive: {
        type: Boolean,
        default: false,
      },
//      part1背景是否为灰色
      bgActive: {
        type: Boolean,
        default: true,
      },

    },
    data() {
      return {
      };
    },
    created() {
      if (this.isWeiXin) {
        // this.showHeader = false;
        document.title = this.title;
        const iframe = document.createElement('iframe');
        iframe.src = './favicon.ico';
        iframe.style.display = 'none';
        iframe.onload = () => {
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 0);
        };
        document.body.appendChild(iframe);
      }
    },
    methods: {
      isWeiXin() {
        const ua = window.navigator.userAgent.toLowerCase();
        const res = ua.match(/MicroMessenger/i);
        return res === 'micromessenger';
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../styles/base';

  .addressFz{
    color: $fontWhite;
    margin-left: 0.1rem;
  }
  .borderBottom{
    border-bottom: 6px solid $borderBottomColor;
  }
  .part1{
    padding-left:0.6rem;
    padding-right: 0.3rem;
  }
  .part1_bg{
    background: $bgColor;
  }
  .part2{
    padding-left:0.6rem;
    padding-right: 0.3rem;
    padding-top:0.24rem;
    background: #fff;
    height: 1.44rem;
    border-bottom: 1px solid $borderBottomColor;
  }
  .part3{
    padding-left:0.6rem;
    padding-right: 0.3rem;
    padding-top:0.24rem;
    background: #fff;
    height: 1.44rem;
    border-bottom: 3px solid $borderBottomColor;
  }
  .unActive{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// index.vue?6c04520e